/* tslint:disable */
/* eslint-disable */
/**
 * Melco Digitizing APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DigitizingserviceMelcoDigitizingModelsOrderAttachment,
    DigitizingserviceMelcoDigitizingModelsOrderAttachmentFromJSON,
    DigitizingserviceMelcoDigitizingModelsOrderAttachmentFromJSONTyped,
    DigitizingserviceMelcoDigitizingModelsOrderAttachmentToJSON,
} from './';

/**
 * 
 * @export
 * @interface DigitizingserviceMelcoDigitizingModelsOrderAlertSubmit
 */
export interface DigitizingserviceMelcoDigitizingModelsOrderAlertSubmit {
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoDigitizingModelsOrderAlertSubmit
     */
    message?: string | null;
    /**
     * 
     * @type {Array<DigitizingserviceMelcoDigitizingModelsOrderAttachment>}
     * @memberof DigitizingserviceMelcoDigitizingModelsOrderAlertSubmit
     */
    attachments?: Array<DigitizingserviceMelcoDigitizingModelsOrderAttachment> | null;
}

export function DigitizingserviceMelcoDigitizingModelsOrderAlertSubmitFromJSON(json: any): DigitizingserviceMelcoDigitizingModelsOrderAlertSubmit {
    return DigitizingserviceMelcoDigitizingModelsOrderAlertSubmitFromJSONTyped(json, false);
}

export function DigitizingserviceMelcoDigitizingModelsOrderAlertSubmitFromJSONTyped(json: any, ignoreDiscriminator: boolean): DigitizingserviceMelcoDigitizingModelsOrderAlertSubmit {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'message': !exists(json, 'message') ? undefined : json['message'],
        'attachments': !exists(json, 'attachments') ? undefined : (json['attachments'] === null ? null : (json['attachments'] as Array<any>).map(DigitizingserviceMelcoDigitizingModelsOrderAttachmentFromJSON)),
    };
}

export function DigitizingserviceMelcoDigitizingModelsOrderAlertSubmitToJSON(value?: DigitizingserviceMelcoDigitizingModelsOrderAlertSubmit | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'message': value.message,
        'attachments': value.attachments === undefined ? undefined : (value.attachments === null ? null : (value.attachments as Array<any>).map(DigitizingserviceMelcoDigitizingModelsOrderAttachmentToJSON)),
    };
}


